import { Project } from "@app/projects";
import { ServiceBase } from "@app/shared";
import CreateProject from "./createProject";
import { querystringify } from "@app/shared/utility";

/** Manages interaction with the project set API. */
export default class CreateProjectService extends ServiceBase {
  /**
   * Creates a new project with a given name, description, and more.
   * @param project The project definition to use in the creation process.
   */
  public async createProject(project: CreateProject, runNow = true): Promise<Project> {
    return await this.makePost<Project>(`projects?${querystringify({ runNow })}`, project);
  }
}
